import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as AlertHexIcon } from "../assets/alertHexIcon.svg";
import { ClinicColors } from "../styles/clinicTheme";

//region [[ Styles ]]

const PartialData = styled("div")({
  display: "flex",
  alignItems: "start",
  gap: 6,
  backgroundColor: ClinicColors.tertiary,
  borderRadius: 4,
  padding: "6px 8px",
  marginBottom: 14,
  "& svg": {
    minWidth: 20,
    height: 20,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface AlertMessageProps {
  message: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AlertMessage = ({ ...props }: AlertMessageProps) => {
  return (
    <PartialData>
      <AlertHexIcon />
      {props.message}
    </PartialData>
  );
};
